import dayJs from 'dayjs';
import { Link } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';
import { getPageURL, PageURL } from 'router/pageURL';
import { NumericFormat } from 'react-number-format';

interface FormattedTableCellProps {
  objectKey: string;
  value: unknown;
  caseId?: string | number;
}

export function isLegacyUuidApplicationId(id: string | unknown | undefined): boolean {
  return typeof id === 'string' && uuidValidate(id);
}

export const FormattedTableCell: any = ({ objectKey, value, caseId }: FormattedTableCellProps) => {
  if (objectKey === 'isTopSlicing') {
    return value ? 'Yes' : 'No';
  }

  if (typeof value !== 'number' && !value) return '-';

  switch (objectKey) {
    case 'createdAt':
    case 'submittedAt':
    case 'updatedAt':
      return dayJs(value as string | Date).format('DD/MM/YYYY HH:mm');
    case 'id': {
      // UUID = unsubmitted legacy application — show id as before (no details link).
      if (isLegacyUuidApplicationId(caseId ?? (typeof value === 'string' ? value : undefined))) {
        return value;
      }

      // CUID = migrated case — show reference number, open details by case id.
      return (
        <Link
          to={getPageURL(PageURL.APPLICATION_DETAILS, { id: String(caseId ?? value) })}
          className={'text-blue-500 no-underline'}
        >
          {String(value)}
        </Link>
      );
    }
    case 'financingAmount':
      return <NumericFormat value={value as number} displayType={'text'} thousandSeparator={true} prefix='£' />;
    default:
      return value;
  }
};
